import axios from 'axios'
import basicParam from '../../../static/config/systemConfig'
import {Indicator,Toast} from 'mint-ui'
import qs from 'qs'
//POST传参序列化
axios.interceptors.request.use(
  config => {
  console.log(config)
  if (config.method === 'post' && config.option && !config.option.noSQ) {

  }else{
    config.data = qs.stringify(config.data)
  }
  return config
  },
error => {
  console.log('错误的传参')
  return Promise.reject(error)
}
)
axios
  .interceptors
  .request
  .use(function (config) {
    Indicator.open();
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
axios.interceptors.response.use(
  response => {
    Indicator.close();
    return response;
  },
  (error) => {
    Indicator.close();
    return Promise.reject('网络出错了')
    if (error.response) {
      switch (error.response.status) {
        case 401:
      }
    }
    return Promise.reject(error.response.data)   // 返回接口返回的错误信息
  });
export function httpRequest(method,data,isFullUrl,option){
  var basicUrl=basicParam.basicUrl;
  var data=data?data:{};
  return axios({
    method: 'post',
    url: isFullUrl?method:(basicUrl+method),
    data: data,
    option:option
  }).then((res)=>{
    return Promise.resolve(res.data);

  }).catch(function(msg){
    console.log(msg);
    return Promise.reject(msg)
  })
}
export function httpGet(method,data,isFullUrl){
  var basicUrl=basicParam.basicUrl;
  var data=data?data:{};
  var url=isFullUrl?method:(basicUrl+method)
  return axios.get(url,{
    params: data
  }).then((res)=>{
    return Promise.resolve(res.data)
  }).catch(function(msg){
    console.log(msg);
  })
}

export var cHttp={
	get:httpGet,
	post:httpRequest
}



// WEBPACK FOOTER //
// ./src/common/js/httpRequest.js